import { z } from 'zod';

export const cropVideoRequestSchema = z.object({
  vaultPath: z.string(),
  startMs: z.number(),
  endMs: z.number(),
  outputFilename: z.string(),
  force: z.boolean().optional(),
});

export type ICropVideoRequest = z.infer<typeof cropVideoRequestSchema>;
